import { LabeledValue } from "@risalabs_frontend_org/oasis-ui-kit";
import { capitalizeWordsSeparatedBySpace } from "../../../../utils/stringModifications";
import {
  EvCoverageValueWithCopy,
  isEvCoverageValueCopyable,
} from "../evCoverageCopyValueButton";

export interface EvCoverageSidebarLabeledValueProps {
  label: string;
  value: string;
}

// For redeploy only

const labelClassName =
  "!text-primaryGray-6 !text-smaller !leading-h11 !font-normal";
const valueClassName =
  "!text-primaryGray-1 !text-smaller !leading-h11 !font-semibold";

/**
 * Label/value row for the EV coverage sidebar with a copy button for
 * every field that holds a real value.
 *
 * @param props.label - Field label
 * @param props.value - Raw field value; placeholders render without a copy button
 */
export const EvCoverageSidebarLabeledValue = (
  props: EvCoverageSidebarLabeledValueProps,
) => {
  const displayValue = capitalizeWordsSeparatedBySpace(props.value ?? "");
  const isCopyable = isEvCoverageValueCopyable(displayValue);

  return (
    <LabeledValue
      label={props.label}
      value={
        isCopyable ? (
          <EvCoverageValueWithCopy label={props.label} value={displayValue} />
        ) : (
          displayValue
        )
      }
      direction="horizontal"
      labelClassName={labelClassName}
      valueClassName={valueClassName}
    />
  );
};
